import { gql } from '@apollo/client'
import { UserFragments } from './fragments'
import { graphql } from '../../graphql-setup'

export const EXPORT_USERS = graphql(`
  mutation ExportUsers(
    $company: ID!
    $exportType: String!
    $exportFormat: ExportFormat
    $exportOption: ExportOption
  ) {
    exportUsers(
      company: $company
      exportType: $exportType
      exportFormat: $exportFormat
      exportOption: $exportOption
    ) {
      ok
      html
      exportTimeout
    }
  }
`)

export const UPDATE_USER_MUTATION = gql`
  mutation updateUserMutation($id: ID!, $input: UpdateUserInput!) {
    updateUserMutation(id: $id, input: $input) {
      user {
        id
      }
    }
  }
`
export const PATCH_USER_MUTATION = graphql(`
  mutation patchUserMutation($id: ID!, $input: PatchUserInput!) {
    patchUserMutation(id: $id, input: $input) {
      user {
        id
        fullName
        phoneNumber
      }
    }
  }
`)

export const TOGGLE_USER_ACTIVATED_MUTATION = gql`
  mutation ToggleUserActivated(
    $userId: ID!
    $active: Boolean!
    $startDate: Date
    $endDate: Date
  ) {
    toggleUserActivated(
      user: $userId
      active: $active
      startDate: $startDate
      endDate: $endDate
    ) {
      user {
        id
        fullName
        isActive
      }
    }
  }
`

export const SEND_NEW_USER_REGISTRATION_MUTATION = gql`
  mutation SendNewUserRegistration($userId: ID!) {
    sendNewUserRegistration(userId: $userId) {
      ok
      user {
        id
        fullName
        isActive
      }
    }
  }
`

export const REGISTER_USER_MUTATION = gql`
  mutation RegisterUserMutation(
    $user: ID
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $birthNumber: String!
    $internalNumber: String!
    $address: String!
    $city: String!
    $postalCode: String!
    $contactPersonName: String!
    $contactPersonPhoneNumber: String!
  ) {
    registerUser(
      user: $user
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      birthNumber: $birthNumber
      internalNumber: $internalNumber
      address: $address
      city: $city
      postalCode: $postalCode
      contactPersonName: $contactPersonName
      contactPersonPhoneNumber: $contactPersonPhoneNumber
    ) {
      ok
      user {
        ...UserInfo
        ...UserTypes
      }
    }
  }
  ${UserFragments.info}
  ${UserFragments.types}
`

export const CREATE_USER_MUTATION = gql`
  mutation CreateUserMutation(
    $email: String!
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $userType: ID!
    $leaderGroup: ID
    $company: String
  ) {
    createUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      userType: $userType
      leaderGroup: $leaderGroup
      company: $company
    ) {
      ok
      user {
        id
        fullName
        phoneNumber
      }
    }
  }
`

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangedPasswordMutation($password: String!, $newPassword: String!) {
    changePassword(password: $password, newPassword: $newPassword) {
      ok
    }
  }
`

export const CREATE_DRIVER_CARD_MUTATION = gql`
  mutation createDriverCard($input: CreateDriverCardInput!) {
    createDriverCard(input: $input) {
      driverCard {
        id
        expiresAt
      }
    }
  }
`
export const PATCH_DRIVER_CARD_MUTATION = gql`
  mutation patchDriverCard($id: ID!, $input: PatchDriverCardInput!) {
    patchDriverCard(id: $id, input: $input) {
      driverCard {
        id
        expiresAt
      }
    }
  }
`

export const DELETE_DRIVER_CARD_MUTATION = gql`
  mutation DeleteDriverCard($id: ID!) {
    deleteDriverCard(id: $id) {
      deletedId
    }
  }
`

export const CREATE_USER_DOCUMENT_MUTATION = gql`
  mutation CreateUserDocument($input: CreateUserDocumentInput!) {
    createUserDocument(input: $input) {
      userDocument {
        id
        name
      }
    }
  }
`

export const PATCH_USER_DOCUMENT_MUTATION = gql`
  mutation PatchUserDocument($id: ID!, $input: PatchUserDocumentInput!) {
    patchUserDocument(id: $id, input: $input) {
      userDocument {
        id
        name
      }
    }
  }
`

export const DELETE_USER_DOCUMENT_MUTATION = gql`
  mutation DeleteUserDocument($id: ID!) {
    deleteUserDocument(id: $id) {
      found
      deletedId
    }
  }
`

// UserDocumentFile

export const CREATE_USER_DOCUMENT_FILE_MUTATION = gql`
  mutation CreateUserDocumentFile($input: CreateUserDocumentFileInput!) {
    createUserDocumentFile(input: $input) {
      userDocumentFile {
        id
      }
    }
  }
`

export const BATCH_CREATE_USER_DOCUMENT_FILE_MUTATION = gql`
  mutation BatchCreateUserDocumentFile(
    $input: [BatchCreateUserDocumentFileInput]!
  ) {
    batchCreateUserDocumentFile(input: $input) {
      userDocumentFiles {
        id
      }
    }
  }
`

export const PATCH_USER_DOCUMENT_FILE_MUTATION = gql`
  mutation PatchUserDocumentFile(
    $id: ID!
    $input: PatchUserDocumentFileInput!
  ) {
    patchUserDocumentFile(id: $id, input: $input) {
      userDocumentFile {
        id
      }
    }
  }
`

export const DELETE_USER_DOCUMENT_FILE_MUTATION = gql`
  mutation DeleteUserDocumentFile($id: ID!) {
    deleteUserDocumentFile(id: $id) {
      deletedId
    }
  }
`

export const CREATE_USER_DOCUMENT_CATEGORY_MUTATION = gql`
  mutation CreateUserDocumentCategory(
    $input: CreateUserDocumentCategoryInput!
  ) {
    createUserDocumentCategory(input: $input) {
      userDocumentCategory {
        id
        name
      }
    }
  }
`

export const PATCH_USER_DOCUMENT_CATEGORY_MUTATION = gql`
  mutation PatchUserDocumentCategory(
    $id: ID!
    $input: PatchUserDocumentCategoryInput!
  ) {
    patchUserDocumentCategory(id: $id, input: $input) {
      userDocumentCategory {
        id
        name
      }
    }
  }
`

export const DELETE_USER_DOCUMENT_CATEGORY_MUTATION = gql`
  mutation DeleteUserDocumentCategory($id: ID!) {
    deleteUserDocumentCategory(id: $id) {
      deletedId
    }
  }
`

export const CREATE_USER_EQUIPMENT_TYPE_MUTATION = gql`
  mutation CreateUserEquipmentType($input: CreateUserEquipmentTypeInput!) {
    createUserEquipmentType(input: $input) {
      userEquipmentType {
        id
        name
        description
        editable
      }
    }
  }
`

export const PATCH_USER_EQUIPMENT_TYPE_MUTATION = gql`
  mutation PatchUserEquipmentType(
    $id: ID!
    $input: PatchUserEquipmentTypeInput!
  ) {
    patchUserEquipmentType(id: $id, input: $input) {
      userEquipmentType {
        id
        name
        description
        editable
      }
    }
  }
`

export const DELETE_USER_EQUIPMENT_TYPE_MUTATION = gql`
  mutation DeleteUserEquipmentType($id: ID!) {
    deleteUserEquipmentType(id: $id) {
      found
      deletedId
    }
  }
`

export const CREATE_USER_EQUIPMENT_MUTATION = gql`
  mutation CreateUserEquipment($input: CreateUserEquipmentInput!) {
    createUserEquipment(input: $input) {
      userEquipment {
        id
        name
        assignedDate
        returnDate
        user {
          id
          fullName
        }
        equipmentType {
          id
          name
        }
      }
    }
  }
`

export const PATCH_USER_EQUIPMENT_MUTATION = gql`
  mutation PatchUserEquipment($id: ID!, $input: PatchUserEquipmentInput!) {
    patchUserEquipment(id: $id, input: $input) {
      userEquipment {
        id
        name
        assignedDate
        returnDate
        user {
          id
          fullName
        }
        equipmentType {
          id
          name
        }
      }
    }
  }
`

export const DELETE_USER_EQUIPMENT_MUTATION = gql`
  mutation DeleteUserEquipment($id: ID!) {
    deleteUserEquipment(id: $id) {
      found
      deletedId
    }
  }
`

export const CREATE_USER_CHILD_MUTATION = graphql(`
  mutation CreateUserChild($input: CreateUserChildInput!) {
    createUserChild(input: $input) {
      userChild {
        id
      }
    }
  }
`)

export const UPDATE_USER_CHILD_MUTATION = graphql(`
  mutation UpdateUserChild($id: ID!, $input: UpdateUserChildInput!) {
    updateUserChild(id: $id, input: $input) {
      userChild {
        id
      }
    }
  }
`)

export const DELETE_USER_CHILD_MUTATION = graphql(`
  mutation DeleteUserChild($id: ID!) {
    deleteUserChild(id: $id) {
      found
    }
  }
`)
